/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from 'antd/lib/tree/utils/iconUtils.tsx';
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import { Icon } from '../../icon';
import { isValidElement, cloneElement } from '../../_util/reactNode';
export default function renderSwitcherIcon(prefixCls, switcherIcon, showLine, { isLeaf, expanded, loading }) {
    if (loading) {
        return React.createElement(LoadingOutlined, { className: `${prefixCls}-switcher-loading-icon` });
    }
    let showLeafIcon;
    if (showLine && typeof showLine === 'object') {
        showLeafIcon = showLine.showLeafIcon;
    }
    if (isLeaf) {
        if (showLine) {
            if (typeof showLine === 'object' && !showLeafIcon) {
                return React.createElement("span", { className: `${prefixCls}-switcher-leaf-line` });
            }
            // return <FileOutlined className={`${prefixCls}-switcher-line-icon`} />;
            return React.createElement(Icon, { type: 'document--filled', size: 'xs', className: `${prefixCls}-switcher-line-icon` });
        }
        return null;
    }
    const switcherCls = `${prefixCls}-switcher-icon`;
    if (isValidElement(switcherIcon)) {
        return cloneElement(switcherIcon, {
            className: classNames(switcherIcon.props.className || '', switcherCls)
        });
    }
    if (switcherIcon) {
        return switcherIcon;
    }
    if (showLine) {
        return expanded ? (React.createElement(Icon, { type: 'substract--square--outline', size: 'xs', className: `${prefixCls}-switcher-line-icon` })) : (React.createElement(Icon, { type: 'add--square--outline', size: 'xs', className: `${prefixCls}-switcher-line-icon` }));
    }
    return React.createElement(Icon, { type: 'chevron--down', size: 'xs', className: switcherCls });
}
